import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import CustomButton from 'Components/CustomButton'
import ListActions from 'Components/ListActions'
import PageTitle from 'Components/PageTitle'
import TicketSaleTargetDrawer from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleTargetDrawer'
import TicketSaleTargetList from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleTargetList'
import useTicketSaleTargetsWithParams from 'Services/SalesManagement/Features/TicketSale/Hooks/useTicketSaleTargetsWithParams'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import { type default as React, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

export default function TicketSaleTargetListPage() {
  const navigate = useNavigate()
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/ticket-sale-targets`
  const title = t`Ticket sale targets`
  const breadcrumbs = [
    {
      title: t`Home`,
      link: SALES_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Ticket sales`
    },
    {
      title: title
    }
  ]

  const {
    data,
    isFetching,
    params,
    setParams,
    selectedTicketSaleTargetId,
    setSelectedTicketSaleTargetId
  } = useTicketSaleTargetsWithParams()
  const [isDrawerOpen, setIsDrawerOpen] = useState(!!selectedTicketSaleTargetId)

  const handleRequestSort = (_event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = params.ordering.includes('-')
    setParams(prevState => ({ ...prevState, ordering: `${isAsc ? '' : '-'}${property}` }))
  }

  const handleChangePage = (_event: unknown, newPage: number) => {
    setParams(prevState => ({ ...prevState, page: newPage + 1 }))
  }

  const handleDrawerClose = () => {
    setSelectedTicketSaleTargetId('')
    setIsDrawerOpen(false)
  }

  const handleRowClick = (id: string) => {
    setSelectedTicketSaleTargetId(id)
    setIsDrawerOpen(true)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs items={breadcrumbs} />
        <PageTitle>{title}</PageTitle>
      </Box>
      <ListActions>
        <CustomButton
          onClick={() => navigate(`${baseUrl}/create`)}
          size="small"
          startIcon={<AddIcon />}
        >
          {t`Create new ticket sale target`}
        </CustomButton>
      </ListActions>
      <TicketSaleTargetList
        rows={data?.results ?? []}
        isLoading={isFetching}
        params={params}
        handleRequestSort={handleRequestSort}
        handleChangePage={handleChangePage}
        count={data?.count ?? 0}
        page={params.page - 1}
        onRowClick={handleRowClick}
        selectedTicketSaleTargetId={selectedTicketSaleTargetId}
      />
      <TicketSaleTargetDrawer
        open={isDrawerOpen}
        handleClose={handleDrawerClose}
        selectedTicketSaleTargetId={selectedTicketSaleTargetId}
      />
    </Box>
  )
}
